import { Helmet } from 'react-helmet-async'

import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import {
  getQueryParamsFromHash, parsePermittedQueryParams,
} from '@domain-group/javascript-utils'

import useAgency from '@hooks/useAgency'
import useCurrentUser from '@hooks/useCurrentUser'
import { generateUrls } from '@hooks/useProviderAccount'

import LinkToEntityModule from '@components/LinkToEntityModule'
import PageHeader from '@components/PageHeader'

import type { AgencyModel } from '@models/types'

import AgencyOrderBundles from '../AgencyOrderBundles'
import AgencyProviderDeadlineGroups from '../AgencyProviderDeadlineGroups'
import AgencyProviderPackages from '../AgencyProviderPackages'
import AgencyPublications from '../AgencyPublications'
import ProviderPriceLists from '../ProviderPriceLists'

interface PageContentProps {
  agency: AgencyModel,
}

const PageContent = (props: PageContentProps) => {
  const { agency } = props
  const { id: agencyId, title: agencyTitle } = agency || {}

  const { redirect }: { redirect?: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const providerAccountPayload = useAgency({ id: agencyId })

  const {
    brand,
    loading,
  } = providerAccountPayload

  const user = useCurrentUser()
  const { provider: { id: providerId, is_publication_provider: isPublicationProvider } } = user

  const { editProviderAccountUrl } = generateUrls({ agency_id: agencyId })

  const {
    title: brandTitle,
    business_name: brandBusinessName,
    logo: brandLogo,
  } = brand || {}

  return (
    <>
      <Helmet>
        <title>Agency Relations | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || '#/systemManager/providerAgencies'}
            size="medium"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey="relations"
        tabBarItems={[
          {
            icon: faIdCard,
            href: editProviderAccountUrl,
            key: 'account',
            title: agencyTitle,
          },
          // @ts-expect-error TS2741
          {
            icon: faIdCard,
            key: 'relations',
            title: 'Relations',
          },
        ]}
        title={agencyTitle}
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <AgencyOrderBundles agencyId={agencyId} />

            <AgencyProviderDeadlineGroups agencyId={agencyId} />

            {/*
             // @ts-expect-error TS2322 */}
            <AgencyProviderPackages agencyId={agencyId} providerId={providerId} />

            {/*
             // @ts-expect-error TS2322 */}
            <ProviderPriceLists agencyId={agencyId} providerId={providerId} />

            {isPublicationProvider && (
              <AgencyPublications agencyId={agencyId} />
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <LinkToEntityModule
              // @ts-expect-error TS2322
              entityTitle={brandTitle}
              imageUrl={brandLogo?.small}
              loading={loading}
              moduleTitle="Brand"
              secondaryText={brandBusinessName}
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
